import React from 'react';
import { useSelector } from 'react-redux';
import checkOutSummarySelectors from '../../components/CheckOutSummary/selectors';
import { EquipmentFinanceCheckoutConfirmation } from '../EquipmentFinanceCheckoutConfirmation';
import { ShiftTradeCheckoutConfirmation } from '../ShiftTradeCheckoutConfirmation';

const CheckoutConfirmation = () => {
  const checkout = useSelector(checkOutSummarySelectors.selectCheckOut);

  return (
    <>
      {checkout.productCode === 'EF' && <EquipmentFinanceCheckoutConfirmation />}
      {checkout.productCode === 'ST' && <ShiftTradeCheckoutConfirmation />}
    </>
  );
};

export default CheckoutConfirmation;
